export default "__VITE_ASSET__CVjosmHf__"